export const MILLIS_PER_SECOND = 1000;

export default function durationSecondsToMillis(value) {
  if (Array.isArray(value)) return value.map(durationSecondsToMillis);
  if (typeof value === 'boolean') return value;

  const seconds = Number(value);
  if (!Number.isFinite(seconds)) return value;
  return Math.round(seconds * MILLIS_PER_SECOND);
}
